import {
  fetcher,
  fetchWithAuth,
  resolvePayload,
  USER_URL,
} from "./const.routes.ts";
import useSWR from "swr";
import { ErrorType } from "../types/Error/Errors.ts";
import { UserType } from "../types/User.ts";
import { Result } from "../types/Result.ts";

export function useUser(id: string, fallback: UserType) {
  const { data, error, isLoading } = useSWR<UserType, Error>(
    USER_URL + id,
    fetcher,
  );
  return {
    user: data ? data : fallback,
    isLoading,
    isError: error,
  };
}

export async function putUser(
  user: Partial<UserType>,
): Promise<Result<UserType, ErrorType>> {
  return await resolvePayload(
    await fetchWithAuth(USER_URL, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    }),
  );
}
